import { Vue, Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import GridDisplayOptions from '@/components/GridDisplayOptions.vue'
import { GetContextMenuItemsParams, GridOptions, MenuItemDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import NonBillableConceptsModal from '@/modules/configurationModule/detail/automation/non-billable-concepts/components/non-billable-concepts-modal/non-billable-concepts-modal.vue'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        GridDisplayOptions,
        NonBillableConceptsModal
    }
})
export default class NonBillableConceptsGrid extends Vue {
    @Ref() readonly nonBillableConceptsModal!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any
    private selectedUnitRates !: Array<object>

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.concept', 1),
                colId: 'concept',
                field: 'concept',
                minWidth: 250,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.code'),
                colId: 'code',
                field: 'code',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.entityType'),
                colId: 'entityType',
                field: 'entityType',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.tc('configuration.sections.unit', 1),
                colId: 'unit',
                field: 'unit',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.priority'),
                colId: 'priority',
                field: 'priority',
                minWidth: 150,
                flex: 1,
                suppressSizeToFit: true,
                filter: true,
                sortable: false
            },
            {
                type: 'checkIconRenderer',
                headerName: i18n.t('configuration.grid.active'),
                colId: 'active',
                field: 'active',
                minWidth: 80,
                suppressSizeToFit: true
            }
        ]
        this.rowData = [
            {
                concept: 'Concepto 1',
                entityType: 'Muestra',
                priority: '1',
                code: '001',
                active: true
            },
            {
                concept: 'Concepto 2',
                entityType: 'Subportion',
                priority: '2',
                code: '002',
                active: true
            },
            {
                concept: 'Concepto 3',
                entityType: 'Subportion',
                priority: '3',
                code: '003',
                active: true
            }
        ]
        this.gridApi = null
    }

    get gridOptions(): GridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: params => {
                this.onGridReady(params)
            },
            onRowSelected: params => {
                this.onRowSelected()
            }
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onRowSelected() {
        this.selectedRows = this.gridApi.getSelectedRows()
    }

    onGridReady({ api }: any) {
        this.gridApi = api
    }

    showNonBillableConceptModal(title: string) {
        this.actionTitle = title
        this.nonBillableConceptsModal.show()
    }

    // TODO: Mejorar esto en Front
    async deleteConcept() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
